import axios from 'axios';
import { loginService } from './LoginService';

export const productsService={
    getProducts,
    searchProduct,
    getProductDetails,
    getProductPrices,
    getProduct
}
function getProducts( pageNumber) {
    let url = `${process.env.REACT_APP_API_URL}/api/products?page[number]=${pageNumber ? pageNumber : 1}`;
  
    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }
  function searchProduct(searchId, pageNumber) {
    let url = `${process.env.REACT_APP_API_URL}/api/products/search?page[number]=${
      pageNumber ? pageNumber : 1
    }${searchId ? `&search_name=${searchId}` : '' }`;

    const requestOptions = {
        method: 'GET',
        url,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json'
        }
      };
      if (loginService.loggedIn()) {
        requestOptions.headers['Authorization'] =loginService.getToken();
      }

      return axios(requestOptions);
  }
  function getProductDetails( productId) {
    let url = `${process.env.REACT_APP_API_URL}/api/products/${productId}`;
  
    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }
  function getProductPrices(productId, startDate, endDate) {
    let url = `${process.env.REACT_APP_API_URL}/api/purchase_prices/latest_prices?product_id=${productId}`;

    if (startDate && endDate) {
        url = `${url}&start_date=${startDate}&end_date=${endDate}`;
    }

    const requestOptions = {
        method: 'GET',
        url,
        headers: {
            Accept: 'application/json',
            'Content-type': 'application/json'
        }
    };

    if (loginService.loggedIn()) {
        requestOptions.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptions);
  }
  function getProduct( productId) {
    let url = `${process.env.REACT_APP_API_URL}/api/products/${productId}/details`;
  
    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }